import { Cookie as UniversalCookie, CookieSetOptions } from 'universal-cookie'
import { useCookies as useReactCookies } from 'react-cookie'
import getFeatureFlags from './getFeatureFlags'

export enum AppCookies {
  IdToken = 'idToken',
  HideSitewideMessages = 'hideSitewideMessages',
  AccessToken = 'accessToken',
  Country = 'country',
  Language = 'language',
  Store = 'store',
  LoggedIn = 'loggedIn',
  IsMarketplaceCatalogEnabled = 'isMarketplaceCatalogEnabled',
  IsBlueErpIntegrationEnabled = 'isBlueErpIntegrationEnabled',
  UserErpType = 'userErpType',
  HasOnlyBlueERP = 'hasOnlyBlueERP',
  IsDarmstadtUser = 'isDarmstadtUser',
  HideEmailVerifionModal = 'hideEmailVerificationModal',
  SSORedirectCookie = 'ssoRedirect',
  MMViewedTransactionIds = 'mmPreviousViewedTransactions', // De-duplication limiter for GA4-410
  ProfileToken = 'profileToken',
  idToken = 'idToken',
  InternalUser = 'internalUser',
  SrpExperience = 'srpExperience',
}

enum CookieSameSite {
  Strict = 'strict',
  None = 'none',
}

export type Cookie = UniversalCookie
export type Cookies = { [name: string]: any }
export type SetCookie = (
  name: string,
  value: Cookie,
  options?: CookieSetOptions
) => void

export type RemoveCookie = (name: string, options?: CookieSetOptions) => void
export type CookiesHook = [Cookies, SetCookie, RemoveCookie]

export const defaultCookieOptions = {
  secure: !!getFeatureFlags().thirdPartyCookies,
  sameSite: getFeatureFlags().thirdPartyCookies
    ? CookieSameSite.None
    : CookieSameSite.Strict,
}

export const useCookies = (cookieList?: string[]): CookiesHook => {
  const [cookies, setCookie, removeCookie] = useReactCookies(cookieList)

  return [
    cookies,
    (name, value, options): void =>
      setCookie(name, value, {
        ...(options || {}),
        ...defaultCookieOptions,
      }),
    (name, options): void =>
      removeCookie(name, {
        ...(options || {}),
        ...defaultCookieOptions,
      }),
  ]
}
